import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import FeedbackManagement from './FeedbackManagement';

const title = 'User Feedback Management';

export default {
  path: '/siteadmin/feedback',

  async action({ store, client }) {
    // From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;

    if (!isAdminAuthenticated) {
      return { redirect: '/siteadmin/login' };
    }

    return {
      title,
      component: (
        <AdminLayout>
          <FeedbackManagement title={title} client={client} />
        </AdminLayout>
      ),
    };
  },
};
